import axios from "axios";
import { getEnterpriseUrl } from "../config/config";
import { fetchCsrfToken } from "./csurfService";
import { isExemptPath } from "../utils/exemptPaths";
import { getGsid , setGSIDCookie} from "../utils/utils";
import { initSession } from "./apiServices"

let enterpriseUrl = getEnterpriseUrl(window.location.host);

const apiService = axios.create({
  baseURL: enterpriseUrl,
  withCredentials: true,
  //enable for https localhost testing for apple pay, do: npm run https for https localhost testing
  //baseURL: "https://retail.boingodev.com/portal/api",
});

let sessionInitialized = false;
let sessionPromise = null;

const ensureSession = () => {
  if (sessionInitialized) return;
  if (!sessionPromise){
    sessionPromise = initSession().then(() => {
      sessionInitialized = true;
    }).catch((err) => {
      console.log("Failed to initialize session",err);
    }).finally(() => {
      sessionPromise = null;
    });
  }
  return sessionPromise
}

const addGSIDToHeader = (config) => {
    const method = config.method?.toUpperCase();
        const g = getGsid();
        if (g !== undefined && g !== ""){
          config.headers["GSID"] = g;
        }
    return method;
}

// Add a request interceptor
apiService.interceptors.request.use(
  async (config) => {
    if (config.url  !== '/session/init'){
        await ensureSession();
    }

    const method = addGSIDToHeader(config);
    // bypass CSRF token check for POST, PUT, PATCH, DELETE requests in isExemptPath
    if (
      ["POST", "PUT", "PATCH", "DELETE"].includes(method) &&
      !isExemptPath(config.url)
    ) {
      const csrfToken = await fetchCsrfToken();
      config.headers["X-CSRF-Token"] = csrfToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
apiService.interceptors.response.use(
  (response) => {
    if (response.headers["gsid"] !== undefined){
      setGSIDCookie(response.headers["gsid"]);
    }
    return response
  } ,
  (error) => {
    if (error.response) {
      console.error("Error response:", {
        status: error.response.status,
        data: error.response.data,
      });
    } else {
      console.error("Error message:", error.message);
    }
    return Promise.reject(error);
  }
);

export default apiService;
